module.exports = __webpack_public_path__ + "img/refund.bceb3468.svg";